export interface I18nDebugContext {
  descriptorId?: string;
  route?: string;
}

let currentContext: I18nDebugContext | null = null;

export function setI18nDebugContext(context: I18nDebugContext | null): void {
  currentContext = context;
}

export function getI18nDebugContext(): I18nDebugContext | null {
  return currentContext;
}
